"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSilentLoginAsync = exports._silentLoginAsync = void 0;
const events_js_1 = require("./events.js");
const renewTokens_js_1 = require("./renewTokens.js");
const timer_js_1 = __importDefault(require("./timer.js"));
// eslint-disable-next-line @typescript-eslint/ban-types
const _silentLoginAsync = (configurationName, configuration, publishEvent) => (extras = null, state = null, scope = null) => {
    if (!configuration.silent_redirect_uri || !configuration.silent_login_uri) {
        return Promise.resolve(null);
    }
    try {
        publishEvent(events_js_1.eventNames.silentLoginAsync_begin, {});
        let queries = '';
        if (state) {
            if (extras == null) {
                extras = {};
            }
            extras.state = state;
        }
        if (scope) {
            if (extras == null) {
                extras = {};
            }
            extras.scope = scope;
        }
        if (extras != null) {
            for (const [key, value] of Object.entries(extras)) {
                if (queries === '') {
                    queries = `?${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                }
                else {
                    queries += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                }
            }
        }
        const link = configuration.silent_login_uri + queries;
        const idx = link.indexOf('/', link.indexOf('//') + 2);
        const iFrameOrigin = link.substr(0, idx);
        const iframe = document.createElement('iframe');
        iframe.width = '0px';
        iframe.height = '0px';
        iframe.id = `${configurationName}_oidc_iframe`;
        iframe.setAttribute('src', link);
        document.body.appendChild(iframe);
        return new Promise((resolve, reject) => {
            try {
                let isResolved = false;
                window.onmessage = (e) => {
                    if (e.origin === iFrameOrigin &&
                        e.source === iframe.contentWindow) {
                        const key = `${configurationName}_oidc_tokens:`;
                        const key_error = `${configurationName}_oidc_error:`;
                        const data = e.data;
                        if (data && typeof (data) === 'string') {
                            if (!isResolved) {
                                if (data.startsWith(key)) {
                                    const result = JSON.parse(e.data.replace(key, ''));
                                    publishEvent(events_js_1.eventNames.silentLoginAsync_end, {});
                                    iframe.remove();
                                    isResolved = true;
                                    resolve(result);
                                }
                                else if (data.startsWith(key_error)) {
                                    const result = JSON.parse(e.data.replace(key_error, ''));
                                    publishEvent(events_js_1.eventNames.silentLoginAsync_error, result);
                                    iframe.remove();
                                    isResolved = true;
                                    reject(new Error('oidc_' + result.error));
                                }
                            }
                        }
                    }
                };
                const silentSigninTimeout = configuration.silent_login_timeout;
                setTimeout(() => {
                    if (!isResolved) {
                        publishEvent(events_js_1.eventNames.silentLoginAsync_error, { reason: 'timeout' });
                        iframe.remove();
                        isResolved = true;
                        reject(new Error('timeout'));
                    }
                }, silentSigninTimeout);
            }
            catch (e) {
                iframe.remove();
                publishEvent(events_js_1.eventNames.silentLoginAsync_error, e);
                reject(e);
            }
        });
    }
    catch (e) {
        publishEvent(events_js_1.eventNames.silentLoginAsync_error, e);
        throw e;
    }
};
exports._silentLoginAsync = _silentLoginAsync;
// eslint-disable-next-line @typescript-eslint/ban-types
const defaultSilentLoginAsync = (window, configurationName, configuration, publishEvent, oidc) => (extras = null, scope = undefined) => {
    extras = Object.assign({}, extras);
    const silentLoginAsync = (extras, state, scope) => {
        return (0, exports._silentLoginAsync)(configurationName, configuration, publishEvent.bind(oidc))(extras, state, scope);
    };
    const loginLocalAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        if (oidc.timeoutId) {
            timer_js_1.default.clearTimeout(oidc.timeoutId);
        }
        let state;
        if (extras && 'state' in extras) {
            state = extras.state;
            delete extras.state;
        }
        try {
            const extraFinal = !configuration.extras ? extras : Object.assign(Object.assign({}, configuration.extras), extras);
            const silentResult = yield silentLoginAsync(Object.assign(Object.assign({}, extraFinal), { prompt: 'none' }), state, scope);
            if (silentResult) {
                oidc.tokens = silentResult.tokens;
                publishEvent(events_js_1.eventNames.token_aquired, {});
                // @ts-ignore
                oidc.timeoutId = (0, renewTokens_js_1.autoRenewTokens)(oidc, oidc.tokens.refreshToken, oidc.tokens.expiresAt, extras);
                return {};
            }
        }
        catch (e) {
            return e;
        }
    });
    return loginLocalAsync();
};
exports.defaultSilentLoginAsync = defaultSilentLoginAsync;
exports.default = exports.defaultSilentLoginAsync;
//# sourceMappingURL=silentLogin.js.map